import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";


interface InlineFormProps {
}

@Dce("InlineForm")
export default class InlineForm extends DceComponent<InlineFormProps> {

    private logger = Logger.of("S");

    constructor(elem: DceHTMLElement, props: InlineFormProps) {
        super(elem, props);

        let focusElem = this.elem.querySelector('[data-role="inline-active"]') as HTMLElement;

        focusElem.addEventListener('input', (e) => {

            let hidden = true;
            if(focusElem instanceof HTMLInputElement || focusElem instanceof HTMLTextAreaElement){
                if(focusElem.value){
                    hidden = false;
                }
            }

            if(hidden){
                this.elem.classList.add('collapsed');
                this.elem.querySelectorAll('.visible').forEach(h => {
                    h.classList.remove('visible');
                    h.classList.add('hidden');
                });
            }else{
                this.elem.classList.remove('collapsed');
                this.elem.querySelectorAll('.hidden').forEach(h => {
                    h.classList.remove('hidden');
                    h.classList.add('visible');
                });
            }


        });

        focusElem.addEventListener('blur', (e) => {

            if(!(focusElem as HTMLInputElement).value){

                // if(focusElem.tagName.toLowerCase() == 'textarea'){
                //     focusElem.style.overflow = 'hidden';
                //     focusElem.style.height = '30px'
                // }

                this.elem.classList.add('collapsed');
                this.elem.querySelectorAll('.visible').forEach(h => {
                    h.classList.remove('visible');
                    h.classList.add('hidden');
                });
            }

        });

    }

}
